const SecondaryTitle =  ({ text} ) => {
  return (
    <h2 className="mobile:max-w-80 small:max-w-screen-mobile desktop:max-w-full mobile:text-base small:text-2xl desktop:text-2xl bg-black font-title bg-gradient-white bg-clip-text text-transparent">{text}</h2>
  )
}

export default SecondaryTitle;